import React from 'react';
import { ThumbsUp, MessageCircle, Heart } from 'lucide-react';
const comments = [{
  name: 'Carlos T.',
  initials: 'CT',
  color: 'bg-blue-600',
  time: '2h',
  text: 'Llevo 3 noches durmiendo 7 horas seguidas. No me lo creo. El audio de emergencia es magia.',
  likes: 47,
  replies: 8,
  reaction: 'love'
}, {
  name: 'Andrea Fernández',
  initials: 'AF',
  color: 'bg-indigo-600',
  time: '5h',
  text: 'Dejé las pastillas hace una semana gracias a esto. Al principio me dio miedo, pero el protocolo funciona.',
  likes: 92,
  replies: 14,
  reaction: 'love'
}, {
  name: 'Luis G.',
  initials: 'LG',
  color: 'bg-slate-600',
  time: '1d',
  text: 'Amigo el que lo está dudando: son $6.39. Yo gastaba más en melatonina al mes.',
  likes: 134,
  replies: 22,
  reaction: 'like'
}, {
  name: 'Sofía Martínez',
  initials: 'SM',
  color: 'bg-emerald-600',
  time: '1d',
  text: 'Dejé de sentir miedo a la cama. DEJÉ DE SENTIR MIEDO. Eso solo vale los $6.39 y más.',
  likes: 78,
  replies: 11,
  reaction: 'love'
}, {
  name: 'Miguel Morales',
  initials: 'MM',
  color: 'bg-amber-600',
  time: '2d',
  text: 'Lo compré a las 2am desesperado. Leí la fase 1 y me calmé. Esa noche dormí mejor.',
  likes: 63,
  replies: 9,
  reaction: 'like'
}, {
  name: 'Camila Reyes',
  initials: 'CR',
  color: 'bg-rose-600',
  time: '2d',
  text: 'Mi mente no paraba de dar vueltas. La técnica de descarga mental es lo único que me ha funcionado.',
  likes: 201,
  replies: 31,
  reaction: 'love'
}, {
  name: 'Alejandra V.',
  initials: 'AV',
  color: 'bg-violet-600',
  time: '3d',
  text: 'Gracias, gracias, gracias. Volví a ser yo. Estaba irritable todo el día por no dormir.',
  likes: 88,
  replies: 15,
  reaction: 'love'
}, {
  name: 'Fernando López',
  initials: 'FL',
  color: 'bg-teal-600',
  time: '4d',
  text: 'Pensé que era otra estafa, pero por el precio me arriesgué. Es contenido de calidad, muy científico pero simple.',
  likes: 156,
  replies: 27,
  reaction: 'like'
}, {
  name: 'Renata Díaz',
  initials: 'RD',
  color: 'bg-cyan-600',
  time: '4d',
  text: 'Noche 5: Dormí sin despertarme ni una vez. Mi esposo no lo puede creer.',
  likes: 243,
  replies: 35,
  reaction: 'love'
}, {
  name: 'Isabela Ruiz',
  initials: 'IR',
  color: 'bg-orange-600',
  time: '5d',
  text: 'El mejor dinero invertido en mi salud mental este año.',
  likes: 112,
  replies: 18,
  reaction: 'love'
}];
export default function FacebookCommentsSection() {
  return <div className="py-10 px-4 sm:px-6 lg:px-8 bg-brand-charcoal" data-id="element-40">
      <div className="max-w-xl mx-auto" data-id="element-41">
        <h3 className="font-heading text-2xl md:text-3xl text-white text-center mb-1 tracking-wide uppercase" data-id="element-42">
          Lo que dicen en redes
        </h3>
        <p className="text-sm text-slate-400 text-center mb-5" data-id="element-43">
          Comentarios reales de nuestra comunidad
        </p>

        <div className="max-h-[420px] overflow-y-auto space-y-2 pr-1 rounded-lg" style={{
        scrollbarWidth: 'thin'
      }} data-id="element-44">
          {comments.map((c, i) => <div key={i} className="bg-brand-dark rounded-lg border border-white/5 px-3 py-2.5" data-id="element-45">
              <div className="flex gap-2.5" data-id="element-46">
                <div className={`w-7 h-7 ${c.color} rounded-full flex items-center justify-center flex-shrink-0`} data-id="element-47">
                  <span className="text-white text-[10px] font-bold" data-id="element-48">
                    {c.initials}
                  </span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-49">
                  <div className="flex items-center gap-1.5 mb-0.5" data-id="element-50">
                    <span className="font-semibold text-slate-200 text-xs" data-id="element-51">
                      {c.name}
                    </span>
                    <span className="text-[10px] text-slate-500" data-id="element-52">
                      · {c.time}
                    </span>
                  </div>
                  <p className="text-slate-300 text-[13px] leading-relaxed mb-1.5" data-id="element-53">
                    {c.text}
                  </p>
                  <div className="flex items-center justify-between" data-id="element-54">
                    <div className="flex items-center gap-1" data-id="element-55">
                      <div className="flex -space-x-1" data-id="element-56">
                        <div className="w-4 h-4 bg-[#1877F2] rounded-full flex items-center justify-center border border-brand-dark" data-id="element-57">
                          <ThumbsUp size={8} className="text-white fill-white" data-id="element-58" />
                        </div>
                        {c.reaction === 'love' && <div className="w-4 h-4 bg-red-500 rounded-full flex items-center justify-center border border-brand-dark" data-id="element-59">
                            <Heart size={8} className="text-white fill-white" data-id="element-60" />
                          </div>}
                      </div>
                      <span className="text-[10px] text-slate-500" data-id="element-61">
                        {c.likes}
                      </span>
                    </div>
                    <div className="flex items-center gap-3 text-[10px] text-slate-500" data-id="element-62">
                      <span className="flex items-center gap-0.5" data-id="element-63">
                        <ThumbsUp size={9} data-id="element-64" /> Me gusta
                      </span>
                      <span className="flex items-center gap-0.5" data-id="element-65">
                        <MessageCircle size={9} data-id="element-66" /> {c.replies}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}